import { WarningAmberRounded } from "@mui/icons-material";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  Typography,
} from "@mui/material";
import { black, greyEnabled, purple, purpleLight, red, redLight } from "../../../theme/colors";

interface Props {
  open: boolean;
  hospitalName?: string;
  isDeleting?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function DeleteHospitalDialog({
  open,
  hospitalName,
  isDeleting = false,
  onClose,
  onConfirm,
}: Props) {
  return (
    <Dialog open={open} onClose={() => !isDeleting && onClose()} PaperProps={{ sx: { borderRadius: 4 } }}>
      <DialogContent sx={{ width: 400, maxWidth: "90vw", p: 4, display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 56,
            height: 56,
            borderRadius: "50%",
            bgcolor: redLight,
            mb: 2,
          }}
        >
          <WarningAmberRounded sx={{ color: red, fontSize: 28 }} />
        </Box>
        <Typography variant="h6" fontWeight={700} color={black} textAlign="center">
          Delete this hospital?
        </Typography>
        <Typography variant="body2" color={greyEnabled} textAlign="center" mt={0.5}>
          {hospitalName
            ? <>You're about to delete <strong>{hospitalName}</strong>. This action cannot be undone.</>
            : "This action cannot be undone."}
        </Typography>

        <Box display="flex" gap={1.5} width="100%" mt={4}>
          <Button
            fullWidth
            disabled={isDeleting}
            onClick={onClose}
            variant="outlined"
            sx={{
              borderColor: purple,
              color: purple,
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              "&:hover": { borderColor: purple, bgcolor: purpleLight },
            }}
          >
            Cancel
          </Button>
          <Button
            fullWidth
            disabled={isDeleting}
            onClick={onConfirm}
            variant="contained"
            disableElevation
            startIcon={isDeleting ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : undefined}
            sx={{
              bgcolor: purple,
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              "&:hover": { bgcolor: "#7A2074" },
            }}
          >
            Delete
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
